import { withInstall } from '../../../utils/with-install'
import InfoWindow from './InfoWindow.vue'

export const ElAmapInfoWindow = withInstall(InfoWindow)
export default ElAmapInfoWindow
